import { render } from "./business-page-header.vue?vue&type=template&id=f047d8d6&ts=true"
import script from "./business-page-header.vue?vue&type=script&lang=ts"
export * from "./business-page-header.vue?vue&type=script&lang=ts"

import "./business-page-header.vue?vue&type=style&index=0&id=f047d8d6&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__